module.exports = __webpack_public_path__ + "img/4-b-squoll-participant-evaluation-md.ccd6b457.png";